import { LoginData } from "../../types/authTypes";

export const set: any = (key: string, value: object): void => {
  if (!localStorage) {
    return;
  }

  try {
    const serializedValue = JSON.stringify(value);
    localStorage.setItem(key, serializedValue);
  } catch (error) {
    throw new Error("store serialization failed");
  }
};

export const get = (key: string): object | undefined => {
  if (!localStorage) {
    return undefined;
  }

  try {
    const serializedValue = localStorage.getItem(key);
    if (serializedValue == null) {
      return undefined;
    }
    return JSON.parse(serializedValue);
  } catch (error) {
    throw new Error("store deserialization failed");
  }
};
